import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames'; // For conditional classes if needed

import DemoFormB2B from '../../components/site/Forms/DemoFormB2B';
import DemoForm from '../../components/site/Forms/DemoForm';

import './PromoBannerCTA.scss';

const PromoBannerCTA = ({
  headline,
  subtexts = [],
  primaryButtonText = "teste grátis", // Default from CardTrialNew usage
  // secondaryButtonText is implicitly "peça uma demonstração" via DemoForm
  isEcommerce = false,
  isReps = false,
  ctaBtn = null, // To pass a fully custom button/form structure
  modalLink = false, // For DemoForm
  inlineBtns = true, // To achieve the two-button layout with DemoForm
  darkBg = false, // Banner is white, so forms shouldn't assume dark BG unless specified
  containerClassName = "promo-banner-cta-container",
  bannerClassName = "promo-banner-cta",
  isAIPage
}) => {
  const HeadlineComponent = isAIPage ? 'h4' : 'h2';
  return (
    <div className={containerClassName}>
      <div className={bannerClassName}>
        <div className="promo-banner-content">
          {headline && <HeadlineComponent className="promo-banner-headline">{headline}</HeadlineComponent>}


          <div className="promo-banner-actions">
            {
              isEcommerce
                ? <DemoFormB2B>{primaryButtonText}</DemoFormB2B>
                : ctaBtn
                  ? ctaBtn
                  : isReps
                    ? <DemoForm darkBg={darkBg} />
                    : <DemoForm
                        trialAndDemo={primaryButtonText}
                        darkBg={darkBg}
                        ctaText // This prop enables the demo button in DemoForm
                        modalLink={modalLink}
                        inlineBtns={inlineBtns}
                        showOr={false} // No "OR" text needed between buttons for this design
                        modalSmall={false}
                      />
            }
          </div>
        </div>
      </div>
    </div>
  );
};

PromoBannerCTA.propTypes = {
  headline: PropTypes.node.isRequired,
  subtexts: PropTypes.arrayOf(PropTypes.string),
  primaryButtonText: PropTypes.string,
  isEcommerce: PropTypes.bool,
  isReps: PropTypes.bool,
  ctaBtn: PropTypes.node,
  modalLink: PropTypes.bool,
  inlineBtns: PropTypes.bool,
  darkBg: PropTypes.bool,
  containerClassName: PropTypes.string,
  bannerClassName: PropTypes.string,
};

export default PromoBannerCTA;


// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/CardFooter/PromoBannerCTA.jsx